import ContactService from "./ContactService"

export default ContactService



// WEBPACK FOOTER //
// ./src/state/contact/services/index.ts